import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { DetailAccordionComponent } from "./components/detail-accordion/detail-accordion.component";
import { PolicyBeneficiaryComponent } from "./components/policy-beneficiary/policy-beneficiary.component";
import { PolicyDocumentsComponent } from "./components/policy-documents/policy-documents.component";
import { PolicyHeaderComponent } from "./components/policy-header/policy-header.component";
import { PolicyTableComponent } from "./components/policy-table/policy-table.component";
import { PolicyDetailComponent } from "./pages/policy-detail/policy-detail.component";
import { PolicyRoutingModule } from "./policy-routing.module";
import { PolicyComponent } from "./policy.component";
import { PolicyQuoteComponent } from "./components/policy-quote/policy-quote.component";
import { PolicyPatrimonioMovimentiComponent } from "./components/policy-patrimonio-movimenti/policy-patrimonio-movimenti.component";
import { PolicyTrasferimentiComponent } from "./components/policy-trasferimenti/policy-trasferimenti.component";
import { PolicySchedaFiscalitaComponent } from "./components/policy-scheda-fiscalita/policy-scheda-fiscalita.component";
import { PolicyEstemporaneiComponent } from "./components/policy-estemporanei/policy-estemporanei.component";
import { PolicySwitchComponent } from "./components/policy-switch/policy-switch.component";

@NgModule({
  declarations: [
    PolicyComponent,
    PolicyDetailComponent,
    PolicyHeaderComponent,
    DetailAccordionComponent,
    PolicyDocumentsComponent,
    PolicyQuoteComponent,
    PolicyBeneficiaryComponent,
    PolicyTableComponent,
    PolicyPatrimonioMovimentiComponent,
    PolicyTrasferimentiComponent,
    PolicySchedaFiscalitaComponent,
    PolicyEstemporaneiComponent,
    PolicySwitchComponent
  ],
  imports: [
    SharedModule,
    PolicyRoutingModule
  ]
})
export class PolicyModule { }
